
import { Component, Mixins, Prop } from "vue-property-decorator";
import OfficeProfileMixin from "../office-profiles.mixin";
import { UserFormDto } from "@/types/user.type";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";
import { OfficeUserDto, OfficeDataDto } from "@/types/office.type";
import { mapState } from "vuex";
import { StatusNames } from "@/common/constants";

@Component({
  computed: {
    ...mapState("OfficeProfile", ["officeData"])
  }
})
export default class OfficeNewUserComponent extends Mixins(OfficeProfileMixin, ValidatedFormMixin) {
  @Prop() modalShow!: boolean;

  officeData!: OfficeDataDto;

  form: UserFormDto = new UserFormDto();

  async addUser(): Promise<void> {
    await this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.setLoading(true);

        this.form.officeId = this.selectedOffice && this.isEdit ? this.selectedOffice.id : null;
        this.form.password = "Password!1";

        const userId = await this.$store.dispatch("OfficeProfile/createUser", this.form);

        if (!this.errorMessage) {
          const user = {
            officeId: this.selectedOffice && this.isEdit ? this.selectedOffice.id : null,
            userId: userId,
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            initials: `${this.form.firstName[0]}${this.form.lastName[0]}`,
            fullName: `${this.form.firstName} ${this.form.lastName}`,
            phoneNumber: this.form.phoneNumber,
            userEmail: this.form.email,
            officeUserStatus: StatusNames.Enabled.getId(this.officeData.statuses)
          } as OfficeUserDto; 

          this.$emit('success', user);
          this.$emit('update:modalShow', false);
        }

        this.setLoading(false);
      }
    });
  }

  closeModal(): void {
    this.$emit('update:modalShow', false);
  }
}
